<script>
import { app } from '@/main'

export default {
  template: '<template></template>',
  components: {},
  props: {},
  data() {
    return {
      contactButtons: [],
    }
  },
  methods: {
    openContact(buttonElm) {
      const contactInformationId = parseInt(
        buttonElm.dataset.contactInformationId
      )

      app.mitt.emit('click-on-contact', contactInformationId)
    },
  },
  created() {
    const owner = this
    const buttons = document.querySelectorAll(
      '.accordion-panel .accordion-content__contact-button'
    )
    buttons.forEach(_button => {
      const button = _button
      owner.contactButtons.push(button)
      button.addEventListener('click', () => {
        owner.openContact(button)
      })
    })
  },
  beforeUnmount() {
    const owner = this
    this.contactButtons.forEach(button => {
      button.removeEventListener('click', () => {
        owner.openContact(button)
      })
    })
    this.contactButtons = []
  },
}
</script>
